import { BooleanString } from 'types/enums';

export function convertToBooleanString(bool: boolean | BooleanString): BooleanString {
  return bool === true || bool === 'true' ? 'true' : 'false';
}

export function convertToBoolean(bool: boolean | BooleanString | undefined): boolean {
  return bool === true || bool === 'true';
}
